import { parsePhoneNumber } from 'libphonenumber-js/mobile'

/** format phone to +x (xxx) xxx-xx-xx format */
export function format(input: string): string {
  let local = false
  let normalized = input.replace(/\s+/g, '').replace(/\++/g, '+').trim()

  if (!input) return ''

  if (normalized.startsWith('8')) {
    local = true
    normalized = '+7' + normalized.substring(1)
  }

  normalized = '+' + normalized.replace(/\D+/g, '')
  const n = parsePhoneNumber(normalized)

  return n.format(local ? 'NATIONAL' : 'INTERNATIONAL')
}
